import ThreeLineTitle from "../components/TheThreeLineTitle.vue";
import { deletePointExcludedProductCode } from "../api";
import { Authorize } from "../utils/authorize";
export default {
    components: { ThreeLineTitle },
    data() {
        return {
            form: {
                non_target_point_grant_id: "",
                point_type_id: "",
                brand_id: "",
                item_code: "",
                item_name: "",
            },
        };
    },
    created() {
        const query = this.$route.query;
        if (query.non_target_point_grant_id)
            this.form.non_target_point_grant_id =
                query.non_target_point_grant_id;
        if (query.point_type_id)
            this.form.point_type_id = query.point_type_id;
        if (query.brand_id)
            this.form.brand_id = query.brand_id;
        if (query.item_code)
            this.form.item_code = query.item_code;
        if (query.item_name)
            this.form.item_name = query.item_name;
    },
    methods: {
        async handleSetting() {
            try {
                const response = await deletePointExcludedProductCode(this.form.non_target_point_grant_id);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    // 削除成功後に交換検索画面へ遷移
                    this.$router.push("/searchPointExcludedProductCode");
                }
            }
            catch (error) {
                //
            }
        },
        onCancel() {
            this.$router.back();
        },
        onSubmit() {
            this.handleSetting();
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
